import React from 'react';

import { expVal } from '@confluence/feature-experiments';

type ArchivedCopyLinkTriggerProps = {
	renderCopyLink: () => React.JSX.Element | undefined;
	// Whether the Share & Restrict button is rendered in the restrictions slot (it provides its
	// own copy-link). Mirrors the contentRestrictions item's non-archived conditions.
	isRestrictionsButtonShown: boolean;
};

// Cleanup: delete this file when confluence_frontend_deprecate_restrictions_dialog graduates.
export const ArchivedCopyLinkTrigger = ({
	renderCopyLink,
	isRestrictionsButtonShown,
}: ArchivedCopyLinkTriggerProps): React.JSX.Element | null => {
	if (
		isRestrictionsButtonShown &&
		expVal('confluence_frontend_deprecate_restrictions_dialog', 'isEnabled', false)
	) {
		// The Share & Restrict button already provides a copy-link — hide the standalone one.
		return null;
	}

	return renderCopyLink() ?? null;
};
